import { apiUserFetch } from '@/api';

import type {
  AuthenticationResponseJSON,
  ConfirmPasskeyLoginResponse,
  MfaCredential,
  MfaCredentialsResponse,
  MfaEnrollment,
  MfaVerificationProof,
  RegistrationResponseJSON,
  StartMfaEnrollmentRequest,
  StartPasskeyLoginResponse,
} from './types';

export const mfaClient = {
  getCredentials: () => apiUserFetch<MfaCredentialsResponse>('/mfa/credentials'),

  startEnrollment: (body: StartMfaEnrollmentRequest, verification?: MfaVerificationProof) =>
    apiUserFetch<MfaEnrollment>('/mfa/enrollments', {
      method: 'POST',
      body: { ...body, ...(verification ? { verification } : {}) },
    }),

  confirmTotpEnrollment: (interactionToken: string, code: string) =>
    apiUserFetch<MfaCredential>('/mfa/enrollments/confirmation', {
      method: 'POST',
      body: { interactionToken, code },
    }),

  confirmPasskeyEnrollment: (interactionToken: string, credential: RegistrationResponseJSON) =>
    apiUserFetch<MfaCredential>('/mfa/enrollments/confirmation', {
      method: 'POST',
      body: { interactionToken, credential },
    }),

  removeCredential: (credentialId: string, verification?: MfaVerificationProof) =>
    apiUserFetch<void>(`/mfa/credentials/${encodeURIComponent(credentialId)}/removal`, {
      method: 'POST',
      body: verification ? { verification } : {},
    }),

  startPasskeyLogin: (email?: string) =>
    apiUserFetch<StartPasskeyLoginResponse>('/auth/passkeys/start', {
      method: 'POST',
      body: email ? { email } : {},
    }),

  confirmPasskeyLogin: (interactionToken: string, assertion: AuthenticationResponseJSON) =>
    apiUserFetch<ConfirmPasskeyLoginResponse>('/auth/passkeys/confirmation', {
      method: 'POST',
      body: { interactionToken, assertion },
    }),
};
